import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { Library } from "lucide-react";

export default function CollectionCard({ collection }) {
  return (
    <Link
      to={`/collections/${collection.id}`}
      data-testid={`collection-card-${collection.id}`}
      className="card-window block no-underline text-black hover:no-underline p-0"
      style={{ textDecoration: "none" }}
    >
      <div className="window-title">
        <span className="text-xs truncate">{collection.name}</span>
        <span className="text-[10px] font-mono">_ □ X</span>
      </div>
      <div className="p-2">
        <div className="relative h-44 bevel-in overflow-hidden bg-white">
          {collection.cover_path ? (
            <img src={fileUrl(collection.cover_path)} alt={collection.name} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full grid place-items-center checkers">
              <div className="bg-white border-2 border-black p-3">
                <Library size={36} className="text-retro-hot" strokeWidth={2} />
              </div>
            </div>
          )}
          <span className="absolute top-2 right-2 tag-90 tag-90-cool">
            {collection.asset_count ?? (collection.asset_ids?.length || 0)} items
          </span>
        </div>
        <div className="mt-2 px-1">
          <div className="font-display text-base truncate font-bold">{collection.name}</div>
          <div className="text-xs font-mono truncate">
            curated by <span className="underline text-retro-link">{collection.owner_name}</span>
          </div>
          {collection.description && (
            <div className="text-xs mt-1 line-clamp-2">{collection.description}</div>
          )}
        </div>
      </div>
    </Link>
  );
}
